'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var React = require('react');
var propTypes = require('prop-types');
var classNames = require('classnames');
var warning = require('@andes/common/build/utils/warning');
var usePreventScroll = require('@andes/common/build/hooks/usePreventScroll');
var useModal = require('@andes/common/build/hooks/useModal');
var webviewTopbarHandler = require('@andes/common/build/utils/webviewTopbarHandler');
var focus = require('@react-aria/focus');
var dialog = require('@react-aria/dialog');
var overlays = require('@react-aria/overlays');
var common = require('@andes/common');
var context = require('@andes/context');
require('@andes/common/build/utils/propTypesValidators');
var Close20 = require('@andes/icons/Close20');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var usePreventScroll__default = /*#__PURE__*/_interopDefaultLegacy(usePreventScroll);
var useModal__default = /*#__PURE__*/_interopDefaultLegacy(useModal);
var Close20__default = /*#__PURE__*/_interopDefaultLegacy(Close20);
const defaultContext = {
  computedCloseButtonLabel: undefined,
  handleClose: undefined,
  headerRef: undefined,
  id: undefined,
  i18n: undefined,
  secondary: undefined,
  secondaryTitleRef: undefined
};
const BottomSheetContext = /*#__PURE__*/React.createContext(defaultContext);
const BottomSheetProvider = _ref => {
  let {
    children,
    computedCloseButtonLabel,
    headerRef,
    handleClose,
    id,
    i18n,
    isPreviousFlow,
    secondary,
    secondaryTitleRef
  } = _ref;
  const contextValue = React.useMemo(() => ({
    computedCloseButtonLabel,
    headerRef,
    handleClose,
    id,
    i18n,
    isPreviousFlow,
    secondary,
    secondaryTitleRef
  }), [headerRef, i18n, handleClose, computedCloseButtonLabel, id, secondaryTitleRef, secondary, isPreviousFlow]);
  return /*#__PURE__*/_jsx__default["default"](BottomSheetContext.Provider, {
    value: contextValue
  }, void 0, children);
};
const namespace = 'andes-bottom-sheet';
const headerNamespace = "".concat(namespace, "__header");
const toggleSizeButton = "".concat(namespace, "__toggle-size-button");
const headerContentNamespace = "".concat(namespace, "__header-content");
const closeNamespace = "".concat(namespace, "__close");
const BottomSheetHeaderContent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    children,
    align = 'left',
    ellipsis = false,
    secondary = false
  } = _ref;
  const headerContentClassNames = classNames__default["default"](headerContentNamespace, {
    ["".concat(headerContentNamespace, "--").concat(align)]: align,
    ["".concat(headerContentNamespace, "--ellipsis")]: ellipsis,
    ["".concat(headerContentNamespace, "--secondary")]: secondary
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: headerContentClassNames,
    ref: ref
  }, children);
});
var BottomSheetHeaderContent$1 = BottomSheetHeaderContent;
const BottomSheetCloseButton = _ref => {
  let {
    close,
    closeOutside,
    computedCloseButtonLabel,
    handleClose
  } = _ref;
  const {
    i18n
  } = React.useContext(BottomSheetContext);
  const closeButtonClassName = classNames__default["default"](closeNamespace, {
    ["".concat(closeNamespace, "--hidden")]: !close,
    ["".concat(closeNamespace, "--outside")]: closeOutside
  });
  return /*#__PURE__*/_jsx__default["default"]("button", {
    "aria-label": computedCloseButtonLabel || i18n.pgettext(namespace, 'cerrar'),
    type: "button",
    className: closeButtonClassName,
    onClick: handleClose
  }, void 0, /*#__PURE__*/_jsx__default["default"](Close20__default["default"], {
    "aria-hidden": true,
    color: closeOutside ? '#fff' : undefined
  }));
};
var BottomSheetCloseButton$1 = BottomSheetCloseButton;
const BottomSheetHeader = _ref => {
  let {
    children,
    dragIndicator = false,
    closeOutside = false,
    close = false,
    ellipsis,
    align
  } = _ref;
  const {
    computedCloseButtonLabel,
    headerRef,
    handleClose,
    id,
    isPreviousFlow,
    secondaryTitleRef,
    secondary
  } = React.useContext(BottomSheetContext);
  const componentId = context.useId(id);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNames__default["default"](headerNamespace, {
      ["".concat(headerNamespace, "--secondary")]: secondary,
      ["".concat(headerNamespace, "--legacy")]: isPreviousFlow
    }),
    ref: headerRef
  }, /*#__PURE__*/_jsx__default["default"]("div", {
    className: classNames__default["default"]({
      ["".concat(namespace, "__drag-indicator")]: dragIndicator
    })
  }), /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(headerNamespace, "-content-container")
  }, void 0, children && /*#__PURE__*/React__default["default"].createElement(BottomSheetHeaderContent$1, {
    id: "".concat(componentId, "-content"),
    ellipsis: secondary || ellipsis,
    align: align,
    secondary: secondary,
    ref: secondaryTitleRef,
    key: "".concat(componentId, "-content")
  }, children), /*#__PURE__*/_jsx__default["default"](BottomSheetCloseButton$1, {
    close: close,
    closeOutside: closeOutside,
    computedCloseButtonLabel: computedCloseButtonLabel,
    handleClose: handleClose
  }, "".concat(componentId, "-close-button"))));
};
var BottomSheetHeader$1 = BottomSheetHeader;
const VisuallyHiddenFocusableWrapper = props => {
  const {
    focusProps,
    isFocusVisible
  } = focus.useFocusRing();
  return /*#__PURE__*/React__default["default"].createElement(common.VisuallyHiddenFocusable, _extends__default["default"]({
    className: classNames__default["default"](toggleSizeButton, {
      ["".concat(toggleSizeButton, "--focused-by-kb")]: isFocusVisible
    })
  }, focusProps, props));
};
var VisuallyHiddenFocusableWrapper$1 = VisuallyHiddenFocusableWrapper;
const computeTitle = _ref => {
  let {
    title,
    titleEllipsis,
    titleAlign
  } = _ref;
  if (typeof title === 'object') {
    return _objectSpread__default["default"](_objectSpread__default["default"]({}, title), {}, {
      align: title.align || 'left'
    });
  }
  return {
    content: title,
    ellipsis: titleEllipsis,
    align: titleAlign || 'left'
  };
};
var computeTitle$1 = computeTitle;
const computeClose = _ref => {
  let {
    closable
  } = _ref;
  return {
    close: !!closable,
    closeOutside: typeof closable === 'string' && closable === 'outside'
  };
};
var computeClose$1 = computeClose;
var module$3 = "@andes/bottom-sheet";
var locale$2 = "en-US";
var translations$2 = {
  "andes-bottom-sheet\u0004cerrar": [null, "Close"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/bottom-sheet";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-bottom-sheet\u0004cerrar": [null, "Cerrar"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/bottom-sheet";
var locale = "pt-BR";
var translations = {
  "andes-bottom-sheet\u0004cerrar": [null, "Fechar"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
const TITLE_PADDING_BOTTOM = 20;
const BottomSheetContainer = /*#__PURE__*/function () {
  const BottomSheetContainer = /*#__PURE__*/React.forwardRef((_ref, containerRef) => {
    let {
      children,
      modal
    } = _ref;
    return modal ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "".concat(namespace, "__overlay"),
      ref: containerRef
    }), children) : children;
  });
  BottomSheetContainer.propTypes = {
    children: propTypes.node,
    modal: propTypes.bool
  };
  return BottomSheetContainer;
}();
const BottomSheet = /*#__PURE__*/function () {
  const BottomSheet = /*#__PURE__*/React.forwardRef((props, ref) => {
    var _BottomSheetHeader;
    const {
      'aria-label': _willdeprecate$ariaLabel,
      action,
      children,
      className,
      closable: _willdeprecate$closable = false,
      closeButtonLabel: _willdeprecate$closeButtonLabel,
      closeButtonSrLabel,
      fixedAction = false,
      header,
      hideDimmer = false,
      id,
      initialHeight,
      isOpen: _willdeprecate$isOpen,
      maxHeight,
      minHeight,
      onClose,
      onOpen,
      open,
      srLabel,
      title: _willdeprecate$titleProp,
      titleAlign: _willdeprecate$titleAlign,
      titleEllipsis: _willdeprecate$titleEllipsis
    } = props;
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const computedSrLabel = srLabel || _willdeprecate$ariaLabel;
    const computedOpen = open || _willdeprecate$isOpen;
    const computedCloseButtonLabel = closeButtonSrLabel || _willdeprecate$closeButtonLabel;
    const {
      current: isPreviousFlow
    } = React.useRef(typeof _willdeprecate$titleProp !== 'undefined' || !header);
    const {
      current: minHeightDefault
    } = React.useRef(hideDimmer ? '60px' : '0px');
    const {
      current: computableMinimumHeight
    } = React.useRef(minHeight || minHeightDefault);
    const {
      content,
      align,
      ellipsis
    } = computeTitle$1({
      title: _willdeprecate$titleProp,
      titleEllipsis: _willdeprecate$titleEllipsis,
      titleAlign: _willdeprecate$titleAlign
    });
    const {
      close,
      closeOutside
    } = computeClose$1({
      closable: _willdeprecate$closable
    });
    const [isVisible, changeIsVisible] = React.useState(computedOpen);
    const [isExpandable, changeIsExpandable] = React.useState(undefined);
    const [isSecondaryVisible, setIsSecondaryVisible] = React.useState(false);
    const [autoFocusToggle, setAutoFocusToggle] = React.useState(true);
    warning__default["default"](computedSrLabel || typeof content === 'string', "<BottomSheet> needs some plain text contents for accessibility\n    reasons. Please add a 'srLabel'");
    const bottomSheetRef = React.useRef();
    const scrollRef = React.useRef();
    const headerRef = React.useRef();
    const secondaryTitleRef = React.useRef();
    const overlayRef = React.useRef();
    const contentRef = React.useRef();
    const actionRef = React.useRef();
    const initialClientHeightRef = React.useRef(0);
    const lastTouchPositionRef = React.useRef({
      y: undefined,
      diff: undefined
    });
    const subscriptionIdsRef = React.useRef();
    const manageDynamicScrollItems = React.useCallback(() => {
      const scrollNode = scrollRef.current;
      const actionNode = actionRef.current;
      const secondaryTitleNode = secondaryTitleRef.current;
      const headerNode = headerRef.current;
      if (!scrollNode) return;
      const {
        scrollHeight,
        scrollTop,
        clientHeight
      } = scrollNode;
      if (actionNode && fixedAction) {
        const isScrollEnd = scrollHeight - Math.abs(scrollTop) === clientHeight;
        actionNode.classList[isScrollEnd ? 'remove' : 'add']("".concat(namespace, "__action--border"));
      }
      if (secondaryTitleNode && headerNode) {
        setIsSecondaryVisible(scrollTop > headerNode.clientHeight - TITLE_PADDING_BOTTOM);
      }
    }, [fixedAction]);
    const handleOnTouchStart = React.useCallback(e => {
      var _e$touches;
      e.stopPropagation();
      const bottomSheetNode = bottomSheetRef.current;
      const scrollNode = scrollRef.current;
      if (e !== null && e !== void 0 && (_e$touches = e.touches) !== null && _e$touches !== void 0 && _e$touches.length && bottomSheetNode && scrollNode) {
        const {
          clientY
        } = e.touches[0];
        lastTouchPositionRef.current = {
          y: Math.round(clientY),
          diff: clientY + scrollNode.scrollTop - bottomSheetNode.offsetTop
        };
      }
    }, []);
    const handleOnTouchMove = React.useCallback(e => {
      var _e$changedTouches;
      e.stopPropagation();
      if (e.cancelable) e.preventDefault();
      const bottomSheetNode = bottomSheetRef.current;
      const overlayNode = overlayRef.current;
      const lastTouchPosition = lastTouchPositionRef.current;
      if (lastTouchPosition && bottomSheetNode && e !== null && e !== void 0 && (_e$changedTouches = e.changedTouches) !== null && _e$changedTouches !== void 0 && _e$changedTouches.length) {
        const touch = Math.round(e.changedTouches[0].clientY);
        if (touch !== lastTouchPosition.y) {
          requestAnimationFrame(() => {
            const newHeight = (overlayNode || document.body).clientHeight - touch + lastTouchPosition.diff;
            bottomSheetNode.style.height = "".concat(newHeight, "px");
          });
          lastTouchPositionRef.current.y = touch;
        }
      }
    }, []);
    const handleOnTouchEnd = React.useCallback((e, handleClose) => {
      e.stopPropagation();
      const bottomSheetNode = bottomSheetRef.current;
      const overlayNode = overlayRef.current;
      const initialClientHeight = initialClientHeightRef.current;
      const lastClientHeight = bottomSheetNode ? bottomSheetNode.clientHeight : undefined;
      if (initialClientHeight && lastClientHeight && bottomSheetNode) {
        if (lastClientHeight === initialClientHeight) return;
        requestAnimationFrame(() => {
          bottomSheetNode.style.transitionDuration = '200ms';
        });
        const availableHeights = [0, (overlayNode || document.body).clientHeight, maxHeight, initialClientHeight];
        const closestHeight = availableHeights.reduce((previous, current) => Math.abs(current - lastClientHeight) < Math.abs(previous - lastClientHeight) ? current : previous);
        if (!closestHeight && !hideDimmer) {
          if (handleClose) handleClose();
          return;
        }
        requestAnimationFrame(() => {
          let newHeight;
          if (!maxHeight && closestHeight === availableHeights[1]) {
            newHeight = closeOutside ? 'calc(100% - 48px)' : '100%';
          } else if (closestHeight > maxHeight) {
            newHeight = "".concat(maxHeight, "px");
          } else if (hideDimmer && closestHeight === 0) {
            newHeight = computableMinimumHeight;
          } else {
            newHeight = "".concat(closestHeight, "px");
          }
          bottomSheetNode.style.height = newHeight;
        });
        if (hideDimmer && closestHeight === 0) {
          changeIsExpandable(false);
        } else {
          changeIsExpandable(true);
        }
        setTimeout(() => {
          bottomSheetNode.style.transitionDuration = '0ms';
        }, 200);
      }
    }, [closeOutside, maxHeight, hideDimmer, computableMinimumHeight]);
    const onScrollMove = React.useCallback(e => {
      var _e$changedTouches2;
      const lastTouchPosition = lastTouchPositionRef.current;
      const overlayNode = overlayRef.current;
      const bottomSheetNode = bottomSheetRef.current;
      const scrollNode = scrollRef.current;
      if (e !== null && e !== void 0 && (_e$changedTouches2 = e.changedTouches) !== null && _e$changedTouches2 !== void 0 && _e$changedTouches2.length && lastTouchPosition && typeof lastTouchPosition.y === 'number' && (hideDimmer || overlayNode) && bottomSheetNode && scrollNode) {
        const overlayHeight = maxHeight !== null && maxHeight !== void 0 ? maxHeight : closeOutside ? (overlayNode || document.body).clientHeight - 48 : (overlayNode || document.body).clientHeight;
        const touch = Math.round(e.changedTouches[0].clientY);
        const isSwipeUp = touch < lastTouchPosition.y;
        const isFullScreen = bottomSheetNode.clientHeight === overlayHeight;
        const isContentScrolled = scrollNode.scrollTop > 0;
        if (isSwipeUp && !isFullScreen || !isSwipeUp && !isContentScrolled) {
          handleOnTouchMove(e);
        }
      }
    }, [closeOutside, handleOnTouchMove, maxHeight, hideDimmer]);
    const setListeners = React.useCallback((method, handleClose) => {
      const headerNode = headerRef.current;
      const contentNode = contentRef.current;
      if (headerNode) {
        headerNode[String(method)]('touchstart', handleOnTouchStart);
        headerNode[String(method)]('touchmove', handleOnTouchMove);
        headerNode[String(method)]('touchend', e => handleOnTouchEnd(e, handleClose));
      }
      if (contentNode) {
        contentNode[String(method)]('touchstart', handleOnTouchStart, true);
        contentNode[String(method)]('touchmove', onScrollMove, true);
        contentNode[String(method)]('touchend', e => handleOnTouchEnd(e, handleClose), true);
      }
    }, [handleOnTouchStart, handleOnTouchMove, handleOnTouchEnd, onScrollMove]);
    const handleClose = React.useCallback(() => {
      const bottomSheetNode = bottomSheetRef.current;
      const overlayNode = overlayRef.current;
      const scrollNode = scrollRef.current;
      if (bottomSheetNode) {
        requestAnimationFrame(() => {
          bottomSheetNode.style.transitionProperty = 'height';
          bottomSheetNode.style.transitionDuration = '200ms';
          bottomSheetNode.style.height = computableMinimumHeight;
          if (!hideDimmer && overlayNode) {
            overlayNode.style.opacity = 0;
          }
        });
        webviewTopbarHandler.enableWebviewTopbar({
          subscriptionIds: subscriptionIdsRef.current
        });
        setTimeout(() => {
          initialClientHeightRef.current = 0;
          changeIsVisible(false);
          setListeners('removeEventListener');
          if (scrollNode) {
            scrollNode.classList.remove("".concat(namespace, "__scroll--scrollable"));
          }
          if (typeof onClose === 'function') onClose();
        }, 300);
      }
    }, [onClose, setListeners, hideDimmer, computableMinimumHeight]);
    const handleOpen = React.useCallback(() => {
      const bottomSheetNode = bottomSheetRef.current;
      const overlayNode = overlayRef.current;
      const scrollNode = scrollRef.current;
      changeIsExpandable(true);
      if (bottomSheetNode) {
        requestAnimationFrame(() => {
          bottomSheetNode.style.transitionProperty = 'height';
          bottomSheetNode.style.transitionDuration = '200ms';
          bottomSheetNode.style.transitionTimingFunction = 'ease-in-out';
          bottomSheetNode.style.height = "".concat(initialHeight || '50%');
          if (!hideDimmer && overlayNode) {
            overlayNode.style.transitionProperty = 'opacity';
            overlayNode.style.opacity = 1;
          }
        });
        subscriptionIdsRef.current = hideDimmer ? webviewTopbarHandler.disableWebviewTopbar({
          onBack: handleClose,
          opacity: 0
        }) : webviewTopbarHandler.disableWebviewTopbar({
          onBack: handleClose
        });
        setTimeout(() => {
          initialClientHeightRef.current = bottomSheetNode.clientHeight;
          manageDynamicScrollItems();
          setListeners('addEventListener', handleClose);
          requestAnimationFrame(() => {
            bottomSheetNode.style.transitionDuration = '0ms';
          });
          if (scrollNode) {
            scrollNode.classList.add("".concat(namespace, "__scroll--scrollable"));
          }
          if (typeof onOpen === 'function') onOpen();
        }, 300);
      }
    }, [initialHeight, setListeners, handleClose, manageDynamicScrollItems, onOpen, hideDimmer]);
    const handleExpanded = React.useCallback(() => {
      const bottomSheetNode = bottomSheetRef.current;
      const initialClientHeight = initialClientHeightRef.current;
      if (!bottomSheetNode) return;
      if (bottomSheetNode.clientHeight < initialClientHeight) {
        handleOpen();
        return;
      }
      changeIsExpandable(false);
      if (!hideDimmer) {
        handleClose();
        return;
      }
      requestAnimationFrame(() => {
        bottomSheetNode.style.transitionProperty = 'height';
        bottomSheetNode.style.transitionDuration = '200ms';
        bottomSheetNode.style.height = computableMinimumHeight;
      });
    }, [initialClientHeightRef, bottomSheetRef, computableMinimumHeight, handleOpen, handleClose, hideDimmer]);
    React.useLayoutEffect(() => {
      if (computedOpen) {
        changeIsVisible(true);
      } else {
        handleClose();
      }
    }, [computedOpen, handleClose]);
    React.useLayoutEffect(() => () => {
      webviewTopbarHandler.enableWebviewTopbar({
        subscriptionIds: subscriptionIdsRef.current
      });
    }, []);
    React.useEffect(() => {
      if (open) setAutoFocusToggle(false);
    }, []);
    const {
      overlayProps
    } = overlays.useOverlay(_objectSpread__default["default"](_objectSpread__default["default"]({}, props), {}, {
      isOpen: computedOpen,
      onClose: handleClose,
      isDismissable: !hideDimmer
    }), bottomSheetRef);
    const {
      dialogProps
    } = dialog.useDialog(_objectSpread__default["default"](_objectSpread__default["default"]({}, props), {}, {
      role: hideDimmer ? 'complementary' : 'dialog',
      isOpen: computedOpen,
      'aria-label': computedSrLabel || (typeof content === 'string' ? content : undefined)
    }), bottomSheetRef);
    const bottomSheetClassnames = classNames__default["default"](namespace, className, {
      ["".concat(namespace, "--secondary")]: isSecondaryVisible,
      ["".concat(namespace, "--fixed-action")]: fixedAction,
      ["".concat(namespace, "--hide-dimmer")]: hideDimmer
    });
    usePreventScroll__default["default"]({
      isDisabled: !isVisible
    });
    if (!hideDimmer) useModal__default["default"]({
      isOpen: isVisible,
      portalSelector: ".".concat(namespace, "__portal")
    });
    if (!isVisible) return null;
    const renderHeader = () => header || _BottomSheetHeader || (_BottomSheetHeader = /*#__PURE__*/_jsx__default["default"](BottomSheetHeader$1, {
      ellipsis: ellipsis,
      align: align,
      dragIndicator: true,
      close: close,
      closeOutside: closeOutside
    }, void 0, content));
    return /*#__PURE__*/_jsx__default["default"](BottomSheetProvider, {
      computedCloseButtonLabel: computedCloseButtonLabel,
      handleClose: handleClose,
      headerRef: headerRef,
      id: id,
      i18n: i18n,
      isPreviousFlow: isPreviousFlow,
      secondary: isSecondaryVisible,
      secondaryTitleRef: secondaryTitleRef
    }, void 0, /*#__PURE__*/React__default["default"].createElement(common.Portal, {
      onMounted: handleOpen,
      className: "".concat(namespace, "__portal"),
      ref: ref
    }, /*#__PURE__*/_jsx__default["default"](focus.FocusScope, {
      contain: !hideDimmer,
      restoreFocus: true,
      autoFocus: autoFocusToggle
    }, void 0, /*#__PURE__*/React__default["default"].createElement(BottomSheetContainer, {
      ref: overlayRef,
      modal: !hideDimmer
    }, /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
      className: bottomSheetClassnames
    }, overlayProps, dialogProps, {
      "data-ismodal": !hideDimmer,
      "aria-modal": !hideDimmer,
      ref: bottomSheetRef
    }), /*#__PURE__*/_jsx__default["default"](VisuallyHiddenFocusableWrapper$1, {
      "aria-expanded": isExpandable,
      onClick: handleExpanded,
      "aria-label": i18n.pgettext(namespace, computedSrLabel || '')
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "".concat(namespace, "__scroll"),
      onScroll: manageDynamicScrollItems,
      ref: scrollRef
    }, children && /*#__PURE__*/React__default["default"].createElement("div", {
      className: classNames__default["default"]({
        ["".concat(namespace, "__content")]: !header
      }),
      ref: contentRef
    }, renderHeader(), children), action && /*#__PURE__*/React__default["default"].createElement("div", {
      className: classNames__default["default"]("".concat(namespace, "__action"), {
        ["".concat(namespace, "__action--legacy")]: isPreviousFlow
      }),
      ref: actionRef
    }, action)))))));
  });
  BottomSheet.displayName = 'BottomSheet';
  return BottomSheet;
}();
var BottomSheet$1 = BottomSheet;
exports.BottomSheet = BottomSheet$1;
exports.BottomSheetHeader = BottomSheetHeader$1;
exports["default"] = BottomSheet$1;
